module.exports = __webpack_public_path__ + "static/Gulbenkian-7d59bd63cd7654bdeec05dd06779d2a4.webp";